import React, {Fragment} from 'react';
import ReactDOM from 'react-dom';
import {MuiThemeProvider as V0MuiThemeProvider} from 'material-ui';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import cyan from '@material-ui/core/colors/cyan';

import {HashRouter, Route, Redirect} from 'react-router-dom';
import IntlProviderWrapper from './components/IntlProviderWrapper';

import Registration from './Registration';

const theme = createMuiTheme({
  palette: {
    primary: cyan,
  },
});

const RegistrationComponent = (props) => (
  <MuiThemeProvider theme={theme}>
    <V0MuiThemeProvider>
      <Registration {...props}/>
    </V0MuiThemeProvider>
  </MuiThemeProvider>
);

ReactDOM.render(
  <IntlProviderWrapper>
    <HashRouter>
      <Fragment>
        <Route exact path="/" render={(props) => {
          return <Redirect exact from="/" to="/step-1"/>;
        }}/>
        <Route path="/" render={(props) => {
          return <RegistrationComponent {...props}/>;
        }}/>
      </Fragment>
    </HashRouter>
  </IntlProviderWrapper>,
  document.getElementById('registrationFormRoot')
);



// WEBPACK FOOTER //
// ./registration-react/index.js